import { ReactNode } from 'react';

import TopMenu from "~/components/TopMenu";
import BreadCrumbs from "~/components/BreadCrumbs";
import Footer from "~/components/Footer";
import type { ITemplateUser } from "~/interfaces";
import { layoutStore } from "~/stores/layout";
import MainTitle from '~/components/MainTitle';
import GlobalStripe from '~/components/GlobalStripe';
import Unauthorized from "~/components/Unauthorized";

import "./style.less";

interface IContentLayout extends ITemplateUser {
	children: ReactNode;
	showGlobalStripe: boolean;
	isAuthorized: boolean;
}

export default function ContentLayout({
	children = null,
	showGlobalStripe = false,
	isAuthorized = false,
	title = "",
	breadcrumbs = [],
	checkInternalRole = "none",
}: IContentLayout) {
	const { showLeftMenu, setShowLeftMenu } = layoutStore(layoutState => ({
		showLeftMenu: layoutState.layout.showLeftMenu,
		setShowLeftMenu: layoutState.setShowLeftMenu,
	}));

	function overlayClick() {
		setShowLeftMenu(false);
	}

	return <div className="contentLayout">
		{ showLeftMenu && <div className="contentLayout__overlay" onClick={overlayClick}></div> }
		<TopMenu checkInternalRole={checkInternalRole} />
		<div className="contentLayout__scrollable">
			<div className="contentLayout__area">
				{ showGlobalStripe && <GlobalStripe /> }
				{ !isAuthorized && <>
					<Unauthorized />
				</> }
				{ isAuthorized && <>
					<BreadCrumbs items={breadcrumbs} />
					<MainTitle title={title} />
					<div className="contentLayout__content">
						{ children }
					</div>
				</> }
			</div>
			<Footer />
		</div>
	</div>;
}
